import React from 'react';
import { Box, Paper, Typography, Skeleton } from '@mui/material';

const PRIMARY = '#f25d27';

/**
 * @param {{
 *   title: string;
 *   value: number;
 *   icon: React.ReactNode;
 *   active?: boolean;
 *   isLoading?: boolean;
 *   onClick?: () => void;
 * }} props
 */
export default function SupportStatCard({ title, value, icon, active, isLoading, onClick }) {
  return (
    <Paper
      onClick={onClick}
      elevation={0}
      sx={{
        p: '16px 20px',
        width: '100%',
        borderRadius: '8px',
        border: active ? `2px solid ${PRIMARY}` : '1px solid #e0e0e0',
        background: '#fff',
        height: '100%',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'border-color 0.15s, box-shadow 0.15s',
        boxShadow: active ? `0 2px 8px ${PRIMARY}22` : '0 1px 3px rgba(0,0,0,0.05)',
        '&:hover': onClick
          ? {
              borderColor: PRIMARY,
              boxShadow: `0 2px 10px ${PRIMARY}20`,
            }
          : {},
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        userSelect: 'none',
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: '10px',
          background: active ? `${PRIMARY}18` : '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: active ? PRIMARY : '#666',
          flexShrink: 0,
          transition: 'color 0.15s, background 0.15s',
        }}
      >
        {icon}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: '0.75rem',
            color: '#888',
            fontWeight: 500,
            mb: 0.25,
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            lineHeight: 1.2,
            minHeight: '2.4em',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {title}
        </Typography>
        {isLoading ? (
          <Skeleton variant="text" width={40} height={28} />
        ) : (
          <Typography
            sx={{
              fontSize: '1.5rem',
              fontWeight: 700,
              color: active ? PRIMARY : '#333',
              lineHeight: 1,
              transition: 'color 0.15s',
            }}
          >
            {value}
          </Typography>
        )}
      </Box>
    </Paper>
  );
}
